import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lyceo-card-header',
  template: `<h4 class="mb-3"><ng-content /></h4>`,
  styleUrls: ['./card-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardHeaderComponent {}
